<template>
  <div class="wrap-login justify-content-center"> 
    <!-- display-flex-center -->
      <div class="col-12 logo-register">
          <div class="center">
             <!-- <img src="@/assets/img/logo.jpg" alt=""> -->
              <img src="@/assets/images/logo_hts_1.png" alt="Hành trang số">
          </div>
      </div>
      <div class="col-xl-3 col-lg-4 col-md-5 col-10 login-form">
        
          <div class="text-center col-12">
            <h2 class="text-left mb-5" style="font-size: 26px;">Đặt lại mật khẩu</h2>
            <div class="text-left" style="color:#879AA9; font-size:13px;">Bạn đã quên mật khẩu. Bạn cần đặt mật khẩu mới để truy cập nền tảng</div>
           <form action=""  @submit.prevent="submitPassword" >
                <div class="text-left form-group">
                  <label for="">Mật khẩu mới</label><br>
                 
                  <input  :type="passwordFieldType" class="form-control input-email" placeholder="Mật khẩu mới"  v-model="user.password">
                  <div v-if="submitted" class="error display-block color-err font-size-14">
                    <span v-if="!$v.user.password.required">Vui lòng điền mật khẩu</span>
                    <span
                      v-if="!$v.user.password.minLength "
                    >Mật khẩu ít nhất 6 ký tự</span>
                  </div>
                  <div class="icon-switch"  v-if="user.password !== ''">
                        <i class="fa" :class="{'fa-eye': statusEye, 'fa-eye-slash': !statusEye}" @click="switchPassword"></i>
                  </div>
                </div>
                <div class="text-left form-group">
                  <label for="">Xác nhận mật khẩu mới</label><br>
                  <input :type="passwordFieldType2" class="form-control input-email" placeholder="Mật khẩu mới"  v-model="user.confirmPassword">
                  <div class="icon-switch"  v-if="user.confirmPassword !== ''">
                        <i class="fa" :class="{'fa-eye': statusEye2, 'fa-eye-slash': !statusEye2}" @click="switchPassword2"></i>
                  </div>
                  <div v-if="submitted" class="error display-block color-err font-size-14">
                    <span v-if="!$v.user.password.required">Vui lòng điền mật khẩu</span>
                    <span v-if="!$v.user.confirmPassword.sameAsPassword">Xác nhận mật khẩu không chính xác</span>
                  </div>
                </div>
                <div class="text-right form-group">
                  <!-- <router-link to="/dang-nhap" exact><button class="btn btn-primary btn-close">Hủy</button></router-link> -->
                   <!-- <router-link to="/trang-chu" exact> -->
                   <button class="btn btn-primary btn-access">Xác nhận</button>
                   <!-- </router-link> -->
                </div>
            </form>
          </div>
      </div>
  </div>
</template>

<script>
  import { required, email, minLength, sameAs } from "vuelidate/lib/validators";
  import { mapGetters, mapActions, mapState } from 'vuex'
  import { MODULE_TEACHER, MODULE_PUBLISHING, MODULE_DEPARTMENT, MODULE_SCHOOL } from '@/store/auth/constants'
  import { apiResetPassword } from '@/store/auth/api'
export default {
  name:"NewPassword",
  data () {
    return {
      password: '',
      statusEye: false,
      statusEye2: false,
      passwordFieldType: 'password',
      passwordFieldType2: 'password',
      useId: this.$route.query.id, 
      code: this.$route.query.code,
      submitted:false,
      user: {
        confirmPassword: '',
        password: ''
      },
    }
  },
  components: {
  },
  validations:{
    user: {
      password: {
        required,
        minLength: minLength(6),
        // goodPassword: password => {
        //   return (
        //     /[a-z]/.test(password) &&
        //     /[A-Z]/.test(password) &&
        //     /[0-9]/.test(password) &&
        //     /[^a-z0-9]/gi.test(password)
        //   );
        // }
      },
      confirmPassword: { required, sameAsPassword: sameAs("password") },
    }
  },
  // created(){
  //   console.log("22222222222222222222",this.$route.query);
  // },
  computed: {
    ...mapState('auth', ['isLoggedIn', 'isLoading', 'errors', 'user'])
  },
  methods: {
    ...mapActions(`auth`, ['authLogin', 'fetchAuthProfile', 'authLoginFacebook', 'authLoginGoogle','authLogout']),
    switchPassword(){
      this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
      this.statusEye = !this.statusEye;
    },
    switchPassword2(){
      this.passwordFieldType2 = this.passwordFieldType2 === 'password' ? 'text' : 'password'
      this.statusEye2 = !this.statusEye2;
    },
    submitPassword(evt) {
      evt.preventDefault();
      this.submitted = true;
      if (this.$v.$invalid) {
        return;
      } 
      apiResetPassword({userId: this.useId, password:this.user.password,confirmPassword:this.user.confirmPassword,code:this.code})
        .then(res => {
         this.ChecksendEmail =false;
         this.$toast.success("Mật khẩu của bạn đã được đặt lại thành công");
         this.$router.push({ path: '/' })
        })
        .catch(err => console.error(err)); 
    },
    onSubmitLogin(evt) {
      evt.preventDefault();
      let self = this;
      const {username, password} = self.form;
      
      self.authLogin({username, password}).then(async res => {
        if(res) {
          let authInfo = await self.fetchAuthProfile();
          if(authInfo && authInfo.roleCode) {
            switch(authInfo.roleCode) {
              case MODULE_TEACHER:
                self.$router.push({path: '/giao-vien'})
                break;
              case MODULE_PUBLISHING:
                self.$router.push({path: '/nha-xuat-ban'})
                break;
              case MODULE_DEPARTMENT:
                self.$router.push({path: '/so-giao-duc-dao-tao'})
                break;
              default:
                self.$router.push({path: '/truong'})
                break;
            }
          }
        }
      })
    },

    onReset(evt) {
      evt.preventDefault()
      this.form.email = ''
      this.form.name = ''
      this.form.checked = []
    },
  }
}

</script>

<style lang="scss" scoped>
.form-group{
  position: relative;
}
.icon-switch{
    position: absolute;
    top: 33px;
    right: 10px;
    i{
    color: #40505E;
    font-size: 14px;
    opacity: .5;
    }
}
.logo-register .center img {
    display: block;
    margin-left: auto;
    margin-right: auto;
    height: 48px;
}
  .wrap-login {height: 100vh;}
  .login-form{
    background-color: #f3f6fb;
    border-radius: 8px;
    margin: auto;
    padding-bottom: 20px;
    .text-center{
      .mb-5 {
          margin-bottom: 1rem !important;
      }
      h2{
        font-weight: bold;
        color: #40505E;
        padding-top: 35px;
      }
      h5{
        font-size: 14px;
        color: #879AA9;
        text-align: left;
      }
      .input-email{
        border-radius: 20px;
        border: 0;
        height: 30px;
        line-height: 30px;
      }
      label{
        color: #879AA9;
      }
      button{
        font-size: 14px;
      }
      .btn-close{
        background-color: #f3f6fb;
        border-radius: 20px;
        border:1px solid #f3f6fb;
        color: #124ABE;
        height: 30px;
        line-height: 15px;
      }
      .btn-access{
        height: 30px;
        line-height: 15px;
        padding-left: 15px;
        padding-right: 15px;
        border-radius: 15px;
        background: #124ABE;
      }
      .auth__input{
        border-radius: 20px;
        border: 1px solid #f3f6fb;
        height: 30px;
      }
      ::-webkit-input-placeholder { /* Edge */
          color: #879AA9;
          font-size: 13px;
      }
      .auth__btn{
        height: 30px;
        background-color: #124ABE;
        line-height: 15px;
      }
      .pd-top{
        padding-top: 20px;
        margin-bottom: 0;
        
      }
      .forgot-pwd{
        font-size: 14px;
            color: #879AA9;
        a{
          color: #124ABE;
        }
      }
    }
  }
  .logo-register{
    padding-top: 50px;
    .center{
      padding-top:10px;
      padding-bottom: 50px;
      img {
        display: block;
        margin-left: auto;
        margin-right: auto;
      }
    }
  }
   @media (min-width: 1200px){
    .col-xl-3.col-lg-4.col-md-5.col-10.login-form {
          max-width: 23%;
    }
  }
</style>